@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-cerrix" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{
                "saveButton" | t
            }}</span>
        </button>
    </div>

    <div class="detail-page-card" [formGroup]="form">
        <div class="detail-page-card-title">{{ "cardTitle" | t }}</div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    data-uiid="mailmessages-detail-send-mail"
                    [label]="'sendMailLabel' | t"
                    [(value)]="mailMessage.Enabled"
                ></cerrix-checkbox>
            </div>
            <div class="form-group">
                <label>{{ "descriptionLabel" | t }}</label>
                <div>
                    <label id="description">{{ mailMessage.Description }}</label>
                </div>
            </div>
            @if (showConditions) {
                <div class="form-group">
                    <label class="col-form-label">{{
                        "conditionsLabel" | t
                    }}</label>
                    <cerrix-select
                        [getDataMethod]="conditionsRequest"
                        formControlName="ConditionsIdList"
                        [multiple]="true"
                        [placeholder]="'All conditions'"
                    >
                    </cerrix-select>
                </div>
            }
            <div class="form-group">
                <cerrix-textfield
                    [dataUiid]="'mailmessages-detail-subject'"
                    [fieldLabel]="'subjectLabel' | t"
                    id="subject"
                    formControlName="subject"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <label>{{ "keywordsLabel" | t }}</label>
                <div data-uiid="mailmessages-detail-keywords">
                    @for (keyword of keywords; track keyword) {
                        <button class="keyword-button" (click)="addKeyword(keyword)">
                            {{ keyword }}
                        </button>
                    }
                </div>
            </div>
            <div class="form-group">
                <label>{{ "messageLabel" | t }}</label>
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="mailMessage.Message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChange($event)"
                    #editor
                ></cerrix-editor>
            </div>
            <div class="form-group">
                <label class="col-form-label">{{
                    "selectedOrganizationsLabel" | t
                }}</label>
                <i
                    class="fas fa-info-circle ms-2"
                    [matTooltip]="noOrganizationsSelectedDescription"
                    position="right"
                ></i>
                <cerrix-select-tree
                    [getDataMethod]="organizationRequest"
                    formControlName="OrganizationIdList"
                    [multiselect]="true"
                >
                </cerrix-select-tree>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
